import React from 'react';
import {connect} from "react-redux";
import { useMap } from 'react-map-gl';


function MapIconLayer() {
  const { current: map } = useMap();

  function defineMapImg(filePath, imgName) {
    if (!map.hasImage(imgName)) {
      map.loadImage(filePath,
        (error, image) => {
          if (error) throw error;
          map.addImage(imgName, image, {sdf: false});
        });
    }
  }

  return null;
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MapIconLayer)